<template>
  <v-card variant="outlined" class="mt-0 mb-3 mt-md-2 mb-md-4 pa-2 d-flex justify-center align-center dashed-border">
    <v-icon
      x-medium
      left
      right
      color="primary"
      class="mx-2"
    >
      mdi-ticket-confirmation-outline
    </v-icon>
    <v-card-title class="justify-center pl-0">
      <span
        class="text-body-2 font-weight-light text-uppercase text-center d-block text-break"
        :class="{ 'text-caption': mobile }"
      >
        {{ $t("entities.ticket", 2) }} disponíveis por comprador: <strong>{{ value }}</strong>
      </span>
    </v-card-title>
  </v-card>
</template>

<script setup lang="ts">
import { useDisplay } from "vuetify";

interface Props {
  value?: number;
}

const { value = 0 } = defineProps<Props>();
const { mobile } = useDisplay();
</script>

<style scoped>
.dashed-border {
  border-style: dashed;
  border-width: 0.17rem;
  border-color: darkgray;
}
</style>
